// Third Party
import React from 'react';
import Modal from '@/views/components/modals/AccessibleModal';

// Components
import GenericContact from '@/types/generic-contact';
import LegacyEditBMOContact from './LegacyEditBMOContact';

type Props = {
  show: boolean;
  contact: Partial<GenericContact>;
  onCancel: () => void;
  onSave: (contact: GenericContact) => GenericContact;
};

const LegacyEditBMOContactModal = (props: Props) => (
  <Modal show={props.show} className="edit-bmo-contact-modal" onHide={props.onCancel} dialogClassName="modal-dialog-centered" backdrop="static">
    <Modal.Body className="d-flex flex-column">
      <LegacyEditBMOContact contact={props.contact} onSave={props.onSave} onCancel={props.onCancel} />
    </Modal.Body>
  </Modal>
);

export default LegacyEditBMOContactModal;
